import React from 'react';

import { Search } from '@mui/icons-material';
import { Grid, InputAdornment, TextField } from '@mui/material';

export interface ClassSessionsToolbarProps {
    searchText: string;
    handleChangeSearch: (event: React.ChangeEvent<HTMLTextAreaElement | HTMLInputElement>) => void;
}

const ClassSessionsStudentToolbar: React.FC<ClassSessionsToolbarProps> = ({ searchText, handleChangeSearch }) => (
    <Grid container>
        <Grid item flexGrow={1}>
            <TextField
                value={searchText}
                onChange={handleChangeSearch}
                size='small'
                variant='standard'
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search />
                        </InputAdornment>
                    )
                }}
            />
        </Grid>
    </Grid>
);

export default ClassSessionsStudentToolbar;
